import { GoToAccountSettingsCTA } from "./ctas";
export var EoriDetailsIA = function EoriDetailsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return WHAT_IS_EORI(strictLocalize);
    },
    getDescription: function getDescription() {
      return [EORI_DEFINITION(strictLocalize), NODE_ON_ORDERS_WITHOUT_EORI(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return GoToAccountSettingsCTA(strictLocalize);
};
var WHAT_IS_EORI = function WHAT_IS_EORI(strictLocalize) {
  return strictLocalize({
    id: "JyA1NQ",
    defaultMessage: "What’s a EORI number?"
  });
};
var EORI_DEFINITION = function EORI_DEFINITION(strictLocalize) {
  return strictLocalize({
    id: "VfEzWr",
    defaultMessage: "The “Economic Operators Registration and Identification” (EORI) number is a unique number used by businesses to identify themselves to customs authorities on customs declarations and other import documentation. You can add or update your EORI number to your Faire profile under the “Import & Tax information” section on “Account Settings” page."
  });
};
var NODE_ON_ORDERS_WITHOUT_EORI = function NODE_ON_ORDERS_WITHOUT_EORI(strictLocalize) {
  return strictLocalize({
    id: "g5oER+",
    defaultMessage: "Note: Orders without a EORI number risk being held at customs and may be returned. If you don’t have an EORI number, you can apply for one on your local government website. The application is free and only takes a few minutes. You’ll receive your EORI number within 3-5 business days."
  });
};